import React from "react";
// import s from "./style.module.css";
import "./risksStyle.css";
import Vizualisation from "../../../../components/Vizualisation";
import useVizualisation from "../../../../helpers/useVizualisation";

const contextOpacity = 0.5;

const RisksDiagram = ({ data, title, note, source, value }) => {
  const { ref, width, height, windowSize, inView } = useVizualisation();

  return (
    <Vizualisation
      title={title}
      note={note}
      source={source}
      ref={ref}
      /*size="large"*/
    >
      <svg viewBox="0 0 400 400" width={width} height={width}>
        <g id="big_circle" data-name="big circle" opacity={contextOpacity}>
          <circle className="cls-3" cx="200" cy="200.04" r="165" />
        </g>
        <g id="pentagram" opacity={contextOpacity}>
          <polygon
            className="cls-3"
            points="200 35.04 42.86 149.87 102.61 333.21 297.3 333.21 357.2 149.87 200 35.04"
          />
        </g>
        <g
          id="middle_circle"
          data-name="middle circle"
          opacity={contextOpacity}
        >
          <circle className="cls-3" cx="200" cy="200.04" r="50.99" />
        </g>
        <g
          id="filler_middle"
          data-name="filler middle"
          opacity={contextOpacity}
        >
          <circle className="cls-3" cx="200" cy="200.04" r="26.38" />
        </g>
        <g
          id="Anticompetitive_practices"
          data-name="Anticompetitive practices"
          opacity={value == "Anticompetitive_practices" ? 1 : 0.3}
          className={value == "Anticompetitive_practices" ? "active" : ""}
        >
          <circle
            id="background-Anticompetitive_practices"
            className="cls-1"
            cx="199.82"
            cy="98.18"
            r="50.99"
          />
          <line
            className="cls-1"
            x1="166.32"
            y1="98.79"
            x2="162.49"
            y2="98.79"
          />
          <circle className="cls-1" cx="159.6" cy="98.69" r="2.91" />
          <line
            className="cls-1"
            x1="230.41"
            y1="106.7"
            x2="235.6"
            y2="106.7"
          />
          <line
            className="cls-1"
            x1="231.34"
            y1="98.94"
            x2="235.6"
            y2="98.94"
          />
          <line
            className="cls-1"
            x1="230.73"
            y1="91.18"
            x2="235.6"
            y2="91.18"
          />
          <circle className="cls-1" cx="238.51" cy="106.7" r="2.91" />
          <circle className="cls-1" cx="238.51" cy="98.94" r="2.91" />
          <circle className="cls-1" cx="238.51" cy="91.18" r="2.91" />
          <line
            className="cls-1"
            x1="156.98"
            y1="99.93"
            x2="159.91"
            y2="95.81"
          />
          <line
            className="cls-1"
            x1="162.28"
            y1="97.55"
            x2="159.41"
            y2="101.58"
          />
          <path
            className="cls-1"
            d="M229.93,89.49l-31.11,9.37L230,108a32.43,32.43,0,0,0-.11-18.55Z"
          />
          <path
            className="cls-1"
            d="M229.93,89.49A32.47,32.47,0,1,0,230,108l-31.22-9.18Z"
          />
          <line
            className="cls-1"
            x1="228.33"
            y1="107.54"
            x2="213.96"
            y2="127.71"
          />
          <line
            className="cls-1"
            x1="206.5"
            y1="130.52"
            x2="223.82"
            y2="106.21"
          />
          <line
            className="cls-1"
            x1="219.31"
            y1="104.89"
            x2="200.43"
            y2="131.38"
          />
          <line
            className="cls-1"
            x1="228.12"
            y1="84.87"
            x2="223.43"
            y2="91.45"
          />
          <line
            className="cls-1"
            x1="195.11"
            y1="131.2"
            x2="214.8"
            y2="103.56"
          />
          <line
            className="cls-1"
            x1="210.29"
            y1="102.23"
            x2="190.31"
            y2="130.27"
          />
          <line
            className="cls-1"
            x1="222.78"
            y1="77.04"
            x2="209.53"
            y2="95.64"
          />
          <line
            className="cls-1"
            x1="216.48"
            y1="93.55"
            x2="225.67"
            y2="80.66"
          />
          <line
            className="cls-1"
            x1="205.78"
            y1="100.91"
            x2="185.95"
            y2="128.74"
          />
          <line
            className="cls-1"
            x1="211.96"
            y1="69.26"
            x2="175.08"
            y2="121.02"
          />
          <line
            className="cls-1"
            x1="166.74"
            y1="94.43"
            x2="184.11"
            y2="70.06"
          />
          <line
            className="cls-1"
            x1="191.49"
            y1="67.36"
            x2="166.59"
            y2="102.3"
          />
          <line
            className="cls-1"
            x1="197.53"
            y1="66.54"
            x2="167.79"
            y2="108.28"
          />
          <line
            className="cls-1"
            x1="172.18"
            y1="117.42"
            x2="207.61"
            y2="67.71"
          />
          <line
            className="cls-1"
            x1="202.82"
            y1="66.77"
            x2="169.72"
            y2="113.23"
          />
          <line
            className="cls-1"
            x1="215.93"
            y1="71.35"
            x2="178.34"
            y2="124.1"
          />
          <line
            className="cls-1"
            x1="201.27"
            y1="99.58"
            x2="181.96"
            y2="126.67"
          />
          <line
            className="cls-1"
            x1="219.53"
            y1="73.95"
            x2="202.59"
            y2="97.73"
          />
        </g>
        <g
          id="Abuse_of_market_power"
          data-name="Abuse of (market) power"
          opacity={value == "Abuse_of_power" ? 1 : 0.3}
          className={value == "Abuse_of_power" ? "active" : ""}
        >
          <circle
            id="background-Abuse_of_power"
            className="cls-1"
            cx="297.23"
            cy="169.19"
            r="50.99"
          />
          <line
            className="cls-1"
            x1="331.59"
            y1="162.14"
            x2="266.48"
            y2="162.14"
          />
          <path
            className="cls-2"
            d="M321.09,157.64a4.66,4.66,0,1,1-3.3,5.71A4.67,4.67,0,0,1,321.09,157.64Z"
          />
          <line
            className="cls-1"
            x1="331.59"
            y1="153.1"
            x2="266.48"
            y2="153.1"
          />
          <path
            className="cls-2"
            d="M306.13,148.6a4.66,4.66,0,1,1-3.3,5.71A4.66,4.66,0,0,1,306.13,148.6Z"
          />
          <line
            className="cls-1"
            x1="331.59"
            y1="144.49"
            x2="266.48"
            y2="144.49"
          />
          <path
            className="cls-2"
            d="M283.49,140.22a4.66,4.66,0,1,1-3.3,5.71A4.65,4.65,0,0,1,283.49,140.22Z"
          />
          <path
            className="cls-2"
            d="M308.18,176.1v-4.79c0-6.13,9.06-5.74,9,.86V199c0,13-28.24,16.81-37.36,5.55l-14-17.43c-1.42-2.14-2.23-4.76-.38-6.61,3.17-3.17,7.25-.17,8.89,1.82,4.11,5,6,7.23,6-.63l-.08-29.06a4.66,4.66,0,1,1,9.3.13V176.1"
          />
          <path
            className="cls-2"
            d="M299.06,176.1v-7.64c.05-5.35-9.43-6.67-9.54.14v7.5"
          />
          <path
            className="cls-2"
            d="M308.18,176.1v-6.74c0-5.35-8.95-6.69-9.12.13"
          />
        </g>
        <g
          id="Excessive_data_collection"
          data-name="Excessive data collection"
          opacity={value == "Excessive_data_collection" ? 1 : 0.3}
          className={value == "Excessive_data_collection" ? "active" : ""}
        >
          <circle
            id="background-Excessive_data_collection"
            className="cls-1"
            cx="260.23"
            cy="282.22"
            r="50.99"
          />
          <path
            className="cls-1"
            d="M271.29,297.33l-15.1,14.94a19.92,19.92,0,0,1-28.14,0l-.39-.39a19.92,19.92,0,0,1,0-28.14l15.09-14.95,8.95,8.95-15.1,14.94a7.25,7.25,0,0,0,0,10.25l.39.4a7.28,7.28,0,0,0,10.26,0l15.1-14.95Z"
          />
          <line
            className="cls-1"
            x1="235.24"
            y1="276.44"
            x2="244.03"
            y2="285.23"
          />
          <line
            className="cls-1"
            x1="254.79"
            y1="295.99"
            x2="263.6"
            y2="304.8"
          />
          <rect
            className="cls-1"
            x="249.01"
            y="250.5"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="245.93"
            y="261.34"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="255.38"
            y="262.32"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="254.97"
            y="239.38"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="253.56"
            y="269.9"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="262.35"
            y="267.47"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="264.29"
            y="280.53"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="275.08"
            y="262.01"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="257.4"
            y="253.93"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="269.48"
            y="286.29"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="274.47"
            y="278.69"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="279.63"
            y="272.12"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="269.93"
            y="272.12"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="277.6"
            y="241.81"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="277.04"
            y="288"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="284.48"
            y="282.02"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="292.96"
            y="263.63"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
          <rect
            className="cls-1"
            x="300.64"
            y="286.67"
            width="4.85"
            height="4.85"
            rx="2.42"
          />
        </g>
        <g
          id="Discrimination_and_bias"
          data-name="Discrimination and bias"
          opacity={value == "Discrimination_and_bias" ? 1 : 0.3}
          className={value == "Discrimination_and_bias" ? "active" : ""}
        >
          <circle
            id="background-Discrimination_and_bias"
            className="cls-1"
            cx="139.7"
            cy="282.22"
            r="50.99"
          />
          <line
            className="cls-1"
            x1="144.02"
            y1="256.6"
            x2="169.17"
            y2="247.42"
          />
          <line
            className="cls-1"
            x1="110.16"
            y1="268.95"
            x2="135.31"
            y2="259.77"
          />
          <line
            className="cls-1"
            x1="139.7"
            y1="316.42"
            x2="139.7"
            y2="262.58"
          />
          <line
            className="cls-1"
            x1="121.94"
            y1="316.42"
            x2="157.46"
            y2="316.42"
          />
          <path
            className="cls-1"
            d="M139.7,253.88a4.31,4.31,0,1,1-4.31,4.31,4.31,4.31,0,0,1,4.31-4.31Z"
          />
          <line
            className="cls-1"
            x1="104.77"
            y1="298.23"
            x2="130.34"
            y2="298.23"
          />
          <path
            className="cls-1"
            d="M105.42,300.8c2.43,4.66,6.86,7.94,12.14,7.94s9.6-3.21,12.05-7.78c.94-1.75.93-2.82.26-4.87L119.4,269.78a1.53,1.53,0,0,0-1-1.08,1.55,1.55,0,0,0-2,1h0c-3.73,10.79-7.47,15.81-11.2,26.61a4.89,4.89,0,0,0,.19,4.52Z"
          />
          <line
            className="cls-1"
            x1="149.06"
            y1="282.33"
            x2="174.62"
            y2="282.33"
          />
          <path
            className="cls-1"
            d="M149.71,284.91c2.42,4.66,6.85,7.93,12.13,7.93s9.6-3.21,12-7.78c.94-1.75.93-2.82.26-4.87l-10.46-26.31a1.56,1.56,0,0,0-3-.12h0c-3.74,10.79-7.48,15.81-11.21,26.61a4.88,4.88,0,0,0,.2,4.53Z"
          />
        </g>
        <g
          id="Lack_of_innovation"
          data-name="Lack of innovation"
          opacity={value == "Lack_of_innovation" ? 1 : 0.3}
          className={value == "Lack_of_innovation" ? "active" : ""}
        >
          <circle
            id="background-Lack_of_innovation"
            className="cls-1"
            cx="102.92"
            cy="169.19"
            r="50.99"
          />
          <line
            className="cls-1"
            x1="102.49"
            y1="131.92"
            x2="102.49"
            y2="138.19"
          />
          <line
            className="cls-1"
            x1="125.25"
            y1="140.59"
            x2="120.81"
            y2="145.03"
          />
          <line
            className="cls-1"
            x1="134.42"
            y1="162.64"
            x2="127.96"
            y2="162.64"
          />
          <line
            className="cls-1"
            x1="124.34"
            y1="188.42"
            x2="119.91"
            y2="183.98"
          />
          <line
            className="cls-1"
            x1="79.35"
            y1="140.59"
            x2="83.79"
            y2="145.03"
          />
          <line
            className="cls-1"
            x1="68.11"
            y1="163.73"
            x2="74.38"
            y2="163.73"
          />
          <line
            className="cls-1"
            x1="78.45"
            y1="188.42"
            x2="82.88"
            y2="183.98"
          />
          <line
            className="cls-1"
            x1="92.4"
            y1="200.19"
            x2="111.29"
            y2="196.95"
          />
          <line
            className="cls-1"
            x1="92.4"
            y1="194.71"
            x2="111.29"
            y2="191.47"
          />
          <path
            className="cls-1"
            d="M92.57,189.61c-.25-14.77-10.56-8.71-11.68-24.22-.79-10.85,9.38-19.7,21-19.7s21.87,8.86,21,19.7c-1.08,12.94-9.49,11-11.26,20.74Z"
          />
          <path
            className="cls-1"
            d="M108.16,199c-.32,2.78-3.57,4.78-7.28,4.47a7.28,7.28,0,0,1-5.34-2.74"
          />
          <polyline
            className="cls-1"
            points="103.86 185.74 105.15 163.87 98.41 166.38 100.61 186.5"
          />
          <line
            className="cls-1"
            x1="67.66"
            y1="206.03"
            x2="139.76"
            y2="133.94"
          />
        </g>
        <g className="fillers" opacity={contextOpacity}>
          <g id="filler_1" data-name="filler 1">
            <circle className="cls-3" cx="280.21" cy="90.46" r="26.38" />
          </g>
          <g id="filler_2" data-name="filler 2">
            <circle className="cls-3" cx="329.19" cy="242.12" r="26.38" />
          </g>
          <g id="filler_3" data-name="filler 3">
            <circle className="cls-3" cx="200" cy="335.73" r="26.38" />
          </g>
          <g id="filler_4" data-name="filler 4">
            <circle className="cls-3" cx="70.89" cy="242.12" r="26.38" />
          </g>
          <g id="filler_5" data-name="filler 5">
            <circle className="cls-3" cx="119.99" cy="90.46" r="26.38" />
          </g>
        </g>
      </svg>
    </Vizualisation>
  );
};

export default RisksDiagram;
